// site data
export const statusOptions = [
  {
    label: 'Active',
    value: 1,
  },
  {
    label: 'Inactive',
    value: 0,
  },
  {
    label: 'Review',
    value: 2,
  },
];

// Returns Yes, No, No Value or Invalid based on the boolean value supposed to be provided.
export const h2aOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
  { label: 'No data', value: null },
];

// columnClasses and sectionClasses variables helps to set classes for columns and sections in one place
// classes for right and left columns
export const columnsClasses = 'flex flex-col sm:flex-row gap-y-4 gap-x-4 lg:gap-x-[88px]';

// classes for sections with header
export const sectionsClasses = {
  sectionClass: 'flex gap-y-4', // space between sections: rowGap=16px+paddingTop=32px=48px
  headerClass: 'text-lg font-bold uppercase',
  sectionDivClass: 'flex flex-col gap-y-4 w-full',
  rightSectionClass: 'flex pt-4 sm:pt-12 gap-y-2.5',
  rightUpperSectionClass: 'flex flex-col gap-y-4',
};

// inputs variables declares in scope of SiteForm component
export const fontSize = 'text-sm';
export const selectFontSize = '14px';
export const asteriskWidth = 'w-2';
export const inputClasses = 'focus-visible:border';
export const inputGroupClasses = 'flex sm:flex-row gap-4 w-full';
export const inputInGroupClass = 'w-full sm:w-1/3';
export const labelTextSize = 'text-sm leading-[14px] font-medium';
export const labelFontSize = 'text-sm leading-[14px]';

export const labelBesideLabelClasses = 'w-1/3 text-base font-normal';
export const labelBesideInputClasses = 'w-2/3 text-base font-normal';
export const errorMessageClass = 'absolute';
export const spaceY = 'space-y-1';
export const placeholders = {
  icon: 'select',
  name: 'enter site name',
  h2a: 'select H2A status',
  county: 'enter county',
  address1: 'enter address line 1',
  address2: 'enter address line 2',
  city: 'enter city',
  state: 'select state',
  zip_code: 'enter ZIP',
  description: 'enter description',
  memo: 'enter memo',
  contact: 'Select...',
  alternateID: 'enter alternate ID',
  alternateName: 'enter alternate name',
  siteType: 'select site type',
  units: 'enter number of units',
  arrival: 'enter arrival date mm/dd/yyyy',
  departure: 'enter departure date mm/dd/yyyy',
  workerCount: 'enter number of workers',
  region: 'enter region',
  latitude: 'set latitude coordinates',
  longitude: 'set longitude coordinates',
  directions: 'enter directions to the site',
};

export const handleH2AValue = (data) => {
  if (data === null) {
    return 'No data';
  }
  return data ? 'Yes' : 'No';
};

export const handleNameValidation = (data) => {
  let inlineErrorMessage = '';
  if (data.data.some((msg) => msg.includes('looks like this site already exists'))) {
    // modify the custom error message to remove the attribute name as a first word of error message (comes from the backend)
    inlineErrorMessage = data.data.find((msg) => msg.startsWith('Name ')).replace('Name ', '');
  } else {
    inlineErrorMessage = data.data.find((msg) => msg.startsWith('Name'));
  }
  return inlineErrorMessage;
};
